import { render } from "./ManufacturerDetail.vue?vue&type=template&id=7ea2f547"
import script from "./ManufacturerDetail.vue?vue&type=script&lang=js"
export * from "./ManufacturerDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Projects/Vue/one-invoice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__